import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Label,
} from "recharts";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

const DashboardChart = ({ data, xAxis, yAxis, xLabel }) => {
  return (
    <Box className={"dashboard-chart-wrap"}>
      <BarChart
        width={400}
        height={250}
        data={data}
        className={"chart"}
        margin={{
          top: 20,
          right: 20,
          left: -20,
          bottom: 20,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis display="none" dataKey={yAxis} axisLine>
          <Label>{xLabel}</Label>
        </XAxis>
        <YAxis display="none" />
        <Tooltip label={xAxis} formatter={(value, name, props) => {
          return [props.payload?.registeredUser, props.payload?.date]
        }} />
        <Bar dataKey={xAxis} fill="#8884d8" />
      </BarChart>
    </Box>
  );
};

DashboardChart.prototype = {
  data: PropTypes.array,
  xAxis: PropTypes.string,
  yAxis: PropTypes.string,
  xLabel: PropTypes.string,
};

export default DashboardChart;
